import React from 'react';
import {
  FormatNumberOptions,
  FormattedNumber,
  IntlShape,
  useIntl,
} from 'react-intl';
import { Unit } from '../stores/products/ProductStore';

export const formatUnit = (
  intl: IntlShape,
  unit: Unit,
  unitDisplay: FormatNumberOptions['unitDisplay'] = 'short'
): string => {
  if (unit === Unit.PCS) {
    return intl.formatMessage({
      defaultMessage: 'pcs',
      description: "Short abreviation for 'peices' (danish stk)",
    });
  }

  let components = intl
    .formatNumber(0, {
      style: 'unit',
      unit,
      unitDisplay,
    })
    .split(' ');
  if (components.length > 1) {
    components.splice(0, 1);
    return components.join(' ');
  }
  return unit;
};

export const FormattedUnit = ({
  unit,
  unitDisplay,
  value,
}: {
  unit: Unit;
  unitDisplay?: FormatNumberOptions['unitDisplay'];
  value?: number | null;
}) => {
  const intl = useIntl();

  return (
    <span>
      {value !== undefined && value !== null ? (
        <>
          <FormattedNumber format="unit" value={value} />{' '}
        </>
      ) : (
        ''
      )}
      {formatUnit(intl, unit, unitDisplay)}
    </span>
  );
};
